/**
 * Gate a whole route on a feature flag, for artists.
 *
 *   { path: 'films', element: <FlagRoute flag="social.film_studio"><FilmStudioPage /></FlagRoute> }
 *
 * Hiding a sidebar row is not a gate: the page is still one typed URL away. This closes that for
 * surfaces that are manager tools first and artist features later.
 *
 * Managers always pass. They reach these pages from the Admin menu, which is not flagged, and a
 * flag at `off` must not lock them out of a tool they use. Everyone else needs the flag; without
 * it they land on their home screen rather than on an error, because from the artist's side the
 * page does not exist yet.
 */
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/features/auth/stores/authStore'
import { UserRole } from '@/types/entities'
import { useFeatures } from './hooks/useFeatures'

export function FlagRoute({ flag, children }: { flag: string; children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user)
  const { isEnabled, isLoading } = useFeatures()

  if (user?.role === UserRole.MANAGER) return <>{children}</>
  // Nothing is known until flags load; render nothing rather than flash the page and take it away.
  if (isLoading) return null
  return isEnabled(flag) ? <>{children}</> : <Navigate to="/app" replace />
}
